import { cn } from '@/lib/cn';
import type { ReactNode } from 'react';

const truncatedLabelClassName = 'min-w-0 flex-1 truncate whitespace-nowrap';

type NavItemLabelContentProps = {
  label: string;
  labelContent?: ReactNode;
  inlineBadge?: ReactNode;
  truncateLabel: boolean;
};

export function NavItemLabelContent({
  label,
  labelContent,
  inlineBadge,
  truncateLabel,
}: NavItemLabelContentProps): JSX.Element {
  const text = labelContent ?? label;

  if (inlineBadge) {
    return (
      <span className={cn('flex items-center', truncateLabel && 'min-w-0 flex-1')}>
        {truncateLabel ? (
          <span className={truncatedLabelClassName}>{text}</span>
        ) : (
          <>{text}</>
        )}
        {inlineBadge}
      </span>
    );
  }

  return <span className={cn(truncateLabel && truncatedLabelClassName)}>{text}</span>;
}
